document.addEventListener('DOMContentLoaded', function(){
  // Mobile menu toggle
  var burger = document.querySelector('.burger');
  var menu = document.querySelector('.mobile-menu');
  if(burger && menu){ burger.addEventListener('click', function(){ menu.classList.toggle('open'); }); }

  // Collection sort
  var sortEl = document.getElementById('kn-sort');
  if(sortEl){ sortEl.addEventListener('change', function(){
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortEl.value);
    window.location.href = url.toString();
  }); }
});
